import type { IconData } from '@stacksjs/iconify-core'

export const otherUiAt: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 8a8 8 0 0 0 8 8h3.75v-2.75H8A5.25 5.25 0 1 1 13.25 8v1.25h-1.5V8A3.75 3.75 0 1 0 8 11.75h8V8A8 8 0 1 0 0 8m9.25 0a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiAt
